'use strict';

class BoletaController {
  constructor($scope, Proyecto, Modal, Util) {
    'ngInject';

    this.$scope = $scope;
    this.Proyecto = Proyecto;
    this.Modal = Modal;
    this.Util = Util;
    this.mostrarBoletas = false;
  }

  $onInit() {
    this.tiposDocumento = [
      {codigo: 'BOLETA', nombre: 'Boleta'},
      {codigo: 'POLIZA', nombre: 'Póliza'},
      {codigo: 'RETENCION', nombre: 'Retención'},
    ];

    this.opcionesFechaInicio = {
      maxDateKey: 'fecha_fin_validez',
    };

    this.opcionesFechaFin = {
      minDateKey: 'fecha_inicio_validez',
    };
    if(this.model.doc_boleta && this.Proyecto && this.Proyecto.proyectoOrigen) {
      let id = this.Proyecto.proyectoOrigen.id_proyecto;
      let cod = this.model.doc_boleta.substr(1, this.model.doc_boleta.indexOf(']')-1);
      this.model.urlDocBoleta = id? `proyectos/${id}/doc/${cod}` : '';
      this.model.urlDocBoletaDescarga = id? `proyectos/${id}/doc/${cod}/descargar` : '';
    }
  }

}

export default BoletaController;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/boleta-garantia/boleta/boleta.controller.js